import React, { useEffect, useState } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

const UploadOrderImageModal = ({ order, onClose, onSave }) => {
    const REACT_APP_API_URL = process.env.REACT_APP_API_URL || window.APP_CONFIG.REACT_APP_API_URL;
    // const REACT_APP_API_URL = window.APP_CONFIG.REACT_APP_API_URL;
    const [furnitureFiles, setFurnitureFiles] = useState([]);
    const [deliveryFiles, setDeliveryFiles] = useState([]);
    const [furniturePreviewImages, setFurniturePreviewImages] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);

    // 家具圖片FileChange
    const handleFurnitureFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        furniturePreviewImages.forEach(img => URL.revokeObjectURL(img.url));
        const previews = files.map(file => ({ name: file.name, url: URL.createObjectURL(file) }));

        setFurniturePreviewImages(prev => [...previews]);
        setFurnitureFiles(prev => [...prev, ...files]);
    };

    // 配送圖片FileChange
    const handleDeliveryFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        previewImages.forEach(img => URL.revokeObjectURL(img.url));
        const previews = files.map(file => ({ name: file.name, url: URL.createObjectURL(file) }));

        setPreviewImages(prev => [...previews]);
        setDeliveryFiles(prev => [...prev, ...files]);
    };

    // 及時更換圖片預覽
    useEffect(() => {
        // 家具圖片
        if (Array.isArray(order?.furnitureImagePath)) {
            setFurniturePreviewImages(
                order.furnitureImagePath.map(path => ({
                    url: `${REACT_APP_API_URL}/public${path}`
                }))
            );
        } else if (order?.furnitureImagePath) {
            setFurniturePreviewImages([
                { url: `${REACT_APP_API_URL}/public${order.furnitureImagePath}` }
            ]);
        }

        // 配送圖片
        if (Array.isArray(order?.imagePath)) {
            setPreviewImages(
                order.imagePath.map(path => ({
                    url: `${REACT_APP_API_URL}/public${path}`
                }))
            );
        } else if (order?.imagePath) {
            setPreviewImages([
                { url: `${REACT_APP_API_URL}/public${order.imagePath}` }
            ]);
        }
    }, [order?.furnitureImagePath, order?.imagePath]);

    return (
        <form>
            <div className="custom-modal-backdrop">
                <div className="custom-modal">
                    <div className="custom-modal-header">
                        <h5 className="modal-title">編輯圖片 {order?.number}</h5>
                        <button className="btn-close" onClick={(e) => { onClose(null); e.preventDefault(); }}></button>
                    </div>

                    <div className="custom-modal-body">
                        {/* 家具照片 */}
                        <div className="input-group mb-3">
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                id={`upload-furniture-${order?.id || 'new'}`}
                                style={{ display: "none" }}
                                onChange={handleFurnitureFileChange}
                            />
                            <label htmlFor={`upload-furniture-${order?.id || 'new'}`} className="btn btn-outline-secondary small-btn">
                                📷 選擇家具照片
                            </label>
                        </div>

                        {furniturePreviewImages.length > 0 && (
                            <div className="input-group mb-3">
                                <p className="fw-bold mb-2">家具圖片：</p>
                                <div className="d-flex flex-wrap gap-2">
                                    {furniturePreviewImages.map((img, index) => (
                                        <div key={index} className="preview-img-wrapper">
                                            <img src={img.url} alt={img.name} className="preview-img" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="input-group mb-3" onClick={() => onSave(furnitureFiles, 'furniture', order.id)}>
                            <label className="btn btn-outline-secondary small-btn">
                                上傳照片
                            </label>
                        </div>

                        {/* 配送照片 */}
                        <div className="image-preview-area mb-3">
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                id={`upload-delivery-${order?.id || 'new'}`}
                                style={{ display: "none" }}
                                onChange={handleDeliveryFileChange}
                            />
                            <label htmlFor={`upload-delivery-${order?.id || 'new'}`} className="btn btn-outline-secondary small-btn">
                                🚚 選擇配送照片
                            </label>
                        </div>

                        {previewImages.length > 0 && (
                            <div className="input-group mb-3">
                                <p className="fw-bold mb-2">配送圖片：</p>
                                <div className="d-flex flex-wrap gap-2">
                                    {previewImages.map((img, index) => (
                                        <div key={index} className="preview-img-wrapper">
                                            <img src={img.url} alt={img.name} className="preview-img" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        <div className="input-group mb-3" onClick={() => onSave(deliveryFiles, 'order', order.id)}>
                            <label className="btn btn-outline-secondary small-btn">
                                上傳照片
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export { UploadOrderImageModal };
